module.exports = __webpack_public_path__ + "static/media/coffee.51c41053.png";